import { Box, Flex, VStack } from '@chakra-ui/layout';
import {
  Button,
  IconButton,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  UseDisclosureProps,
} from '@chakra-ui/react';
import { Icon } from '@common/components/Icon';
import { Image } from '@common/components/Image';
import React from 'react';
import { TextBlock } from 'src/apps/invest/common/components/TextBlock';
import { useSurveyBannerModel } from '../models/SurveyBannerModel';
import { ProgressBar } from './Step';

type VerifyIdentityProps = {
  modalProps: UseDisclosureProps;
};

export const VerifyIdentity: React.FC<VerifyIdentityProps> = ({ modalProps }) => {
  const model = useSurveyBannerModel();

  return (
    <ModalContent>
      <ModalHeader
        display={'flex'}
        alignItems={'center'}
        justifyContent={'space-between'}
        borderBottomWidth={'1px'}
        borderBottomColor={'gray.300'}>
        Verify Identity
        <IconButton
          color="black"
          variant={'ghost'}
          aria-label="Back"
          icon={<Icon icon="times" />}
          onClick={modalProps.onClose}
        />
      </ModalHeader>
      <ModalBody>
        <Flex flex={1} pt={'24px'} justifyContent={'space-between'} flexDirection={'column'} display={'flex'}>
          <VStack alignItems={'flex-start'} gap={'24px'} mb="100px">
            <Box w={'50%'} m={'auto'}>
              <Image image={'verify-identity'} />
            </Box>
            <Box mt={'24px'} w={'100%'}>
              <TextBlock
                mr={'10px'}
                fontSize={'12px'}
                whiteSpace="nowrap"
                color={'blue.500'}
                weight="bold">{`Step 2 of 4`}</TextBlock>
              <TextBlock whiteSpace="nowrap" weight="bold">
                Verify Identity
              </TextBlock>
              <ProgressBar currentStep={1} totalSteps={4} />
            </Box>
            <Box>
              <TextBlock textAlign={'left'} weight="bold" fontSize={'18px'} lineHeight={'18px'} mb="10px">
                Making sure you’re not a robot
              </TextBlock>
              <TextBlock mt={'5px'} fontSize={'14px'}>
                Financial regulations require that we collect information needed to confirm the identities of all
                investors. This helps to protect you from identity theft.
              </TextBlock>
            </Box>
          </VStack>
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button
          autoFocus={true}
          isLoading={model.loading}
          isDisabled={false}
          w={'100%'}
          rightIcon={<Icon icon="chevron-right" />}
          mt={'10px'}
          onClick={() => model.nextStep()}>
          Continue
        </Button>
      </ModalFooter>
    </ModalContent>
  );
};
